
import { isProductSellable } from '@/helpers/shopify/product'
import Button from '@/components/buttons/Button'
export default {
  components: {
    Button,
  },
  props: {
    wording: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  methods: {
    isSellable() {
      return isProductSellable(this.$i18n.locale, this.$config)
    },
  },
}
